
const Instructor = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-4xl font-bold text-center text-gray-800 mb-12">
            Quem Sou <span className="text-[#E18E37]">Eu</span>?
          </h2>
          
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="order-2 md:order-1">
              <div className="space-y-4">
                <p className="text-gray-700 text-lg leading-relaxed">
                  Olá! Sou um profissional qualificado com anos de experiência em instalações 
                  elétricas residenciais e comerciais.
                </p>
                <p className="text-gray-700 text-lg leading-relaxed">
                  Minha missão é compartilhar todo o conhecimento adquirido ao longo da minha 
                  carreira de forma clara, direta e prática, para que você possa aprender 
                  de verdade e aplicar no dia a dia.
                </p>
                <p className="text-gray-700 text-lg leading-relaxed">
                  Já formei centenas de alunos que hoje trabalham com confiança e segurança 
                  na área elétrica. Agora é a sua vez!
                </p>
                
                <div className="pt-6 space-y-3">
                  <div className="flex items-center space-x-3">
                    <svg className="w-6 h-6 text-[#E18E37]" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"></path>
                    </svg>
                    <span className="text-gray-700 font-medium">Mais de 10 anos de experiência</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <svg className="w-6 h-6 text-[#E18E37]" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"></path>
                    </svg>
                    <span className="text-gray-700 font-medium">Certificações profissionais</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <svg className="w-6 h-6 text-[#E18E37]" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"></path>
                    </svg>
                    <span className="text-gray-700 font-medium">Centenas de alunos formados</span>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="order-1 md:order-2">
              <div className="relative">
                <div className="absolute inset-0 bg-[#E18E37] rounded-lg transform rotate-3"></div>
                <img 
                  src="/images/IMG_5663 (1).PNG" 
                  alt="Instrutor do Curso" 
                  className="relative rounded-lg shadow-2xl w-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Instructor;
